// removed by extract-text-webpack-plugin
module.exports = {"component":"MedicineGuide__component___3GMY4","text":"MedicineGuide__text___2JCIg","smallText":"MedicineGuide__smallText___11lBL","title":"MedicineGuide__title___UenfL"};


//////////////////
// WEBPACK FOOTER
// ./src/homepage/components/MedicineGuide.css
// module id = 419
// module chunks = 0